<template>
  <div class="w-full">
    <info-panel class="my-4 relative gateway-column-content">
      <template slot="content">
        <div class="w-full h-full rounded-t-lg relative">
          <div
            class="bg-contain bg-no-repeat bg-center h-48 w-full"
            :style="{
              backgroundImage:
                'url(' +
                require('../assets/images/logo/' +
                  gatewayIntegration.platform +
                  '-integration.png') +
                ')',
            }"
          ></div>
        </div>
      </template>
      <template slot="footer">
        <div class="flex w-full pl-4 justify-between items-center">
          <div class="flex flex-col items-center justify-center w-full">
            <div class="flex flex-col justify-left w-full">
              <p class="text-sm">
                {{ gatewayIntegration.name }}
              </p>
            </div>
          </div>
          <drop-menu :menu-items="menuItems" small></drop-menu>
        </div>
      </template>
    </info-panel>
  </div>
</template>

<script>
export default {
  name: 'FunnelGridAsset',
  data() {
    return {};
  },
  props: {
    gatewayIntegration: {},
  },
  computed: {
    menuItems() {
      const menuItems = [];

      menuItems.push({
        text: this.$t('frontend_groovesell_reporting_overide'),
        callback: () =>
          this.$emit('onProcessingFeeClick', this.gatewayIntegration.id),
      });

      return menuItems;
    },
  },
  methods: {},
};
</script>
<style lang="scss">
.gateway-column-content {
  width: 270px !important;
  height: 270px !important;
}
</style>